<template>
  <b-modal
    id="reject-modal"
    size="lg"
    :title-html="'<i class=\'uil-ban text-danger\'></i>' + $t('job.applicant_window.action.reject_candidate.window_title')"
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    centered
    body-class="bg-light"
    static
    :ok-title-html="'<i class=\'uil-bane\'></i>' + $t('job.applicant_window.action.reject_candidate.ok_button')"
    ok-variant="danger"
    @ok="handleOk"
    button-size= 'sm'
    :cancel-title= "$t('job.applicant_window.action.reject_candidate.cancel_button')"
    footer-class= 'p-2'
    hide-header-close
    >
    <div class="row">
      <div class="form-group col-md-12">
        <label class="form-label">{{$t('job.applicant_window.action.reject_candidate.reason_for_rejection.label')}}:</label>
        <textarea 
          class="form-control"
          v-model="reason"
          rows="5" :placeholder="$t('job.applicant_window.action.reject_candidate.reason_for_rejection.placeholder') + '...'"></textarea>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data(){
    return {
      reason:''
    }
  },
  props:['application'],
  computed:{
    getApplication(){
      return this.$props.application || {}
    }
  },
  methods:{
    ...mapActions('candidate', ['rejectApplication']),
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      if(!this.reason){
        alert('Please enter a reason')
        return
      }
      this.rejectApplication({
        application_id:this.getApplication._id,
        reason:this.reason
      }).then(res => {
        if(res.data){
          this.$bvToast.toast(`Candidate is now rejected!`, {
            title: 'Notification',
            variant:'success'
          })
          this.$props.application.rejected = res.data.rejected
          this.$props.application.status = res.data.status
          this.$props.application.rejection_reason = res.data.rejection_reason
          this.reason = ''
        }
        this.$bvModal.hide('reject-modal')
      })
    }
  },
}
</script>
